<template lang="pug">
  .video-view(ref="container")
    v-menu(v-model='openEditDialog' :nudge-width='400' absolute :close-on-content-click="false")
      template(v-slot:activator='{ on, attrs }')
        div(class="fr-view" v-bind='attrs' v-on='on')
          div(class="fr-video")
            iframe(width="640" :height="height" :src="content.value.src" frameborder="0" :style="attrs['aria-expanded'] === 'true'? '' : 'pointer-events: none;'" allowfullscreen)
      v-card
        v-card-title.font-weight-bold.mt-n1 {{ $t('change_url') }}
        v-card-text.my-n2
          v-text-field(v-model="newUrl" hide-details outlined dense)
        v-card-actions
          v-spacer
          v-btn.mb-2(small text @click.native="openEditDialog = false; newUrl = ''") {{ $t('cancel') }}
          v-btn.mb-2.mr-2(small depressed dark color="accent" @click="changeUrl()") {{ $t('update') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'VideoView',
  props: ['content'],
  data: () => ({
    isReady: false,
    openEditDialog: false,
    newUrl: '',
    valid: false,
    videos: [
        {
          // eslint-disable-next-line
          reg:/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/i,
          url: 'https://www.youtube.com/embed/$5',
          params: {
            'picture-in-picture': 1,
            accelerometer: 1,
            gyroscope: 1
          }
        },
        {
          // eslint-disable-next-line
          reg: /^.*vimeo.com\/(\d+)($|\/|\b)/i,
          url: 'https://player.vimeo.com/video/$1',
          params: {
            title: 0,
            byline: 0,
            portrait: 0
          },
        },
        {
          // eslint-disable-next-line
          reg: /^.*(?:\/video|dai.ly)\/([A-Za-z0-9]+)([^#\&\?]*).*/i,
          url: 'https://www.dailymotion.com/embed/video/$1',
          params: {
              autoplay: 0
          }
        },
        {
          // eslint-disable-next-line
          reg: /^.*coub.com\/(?:embed|view)\/([A-Za-z0-9]+)([^#\&\?]*).*/i,
          url: 'https://coub.com/embed/$1',
          params: {
              autoplay: 0
          }
        },
        {
          // eslint-disable-next-line
          reg: /^.*twitch.tv\/videos\/(\d+)($|\/|\b)/i,
          url: 'https://player.twitch.tv/?autoplay=false&video=v$1',
          params: {
              autoplay: false
          },
          callback: function () {
              return 'https://player.twitch.tv/?video=v$1';
          }
        }
    ],
  }),
  computed: {
    height () {
      if (this.isReady) {
        return this.$refs.container.clientWidth/1.77
      }
      return 360
    }
  },
  mounted () {
    this.isReady = true
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    changeUrl () {
      this.valid = false
      if (this.newUrl) {
        for (let i = 0; i < this.videos.length; i++) {
          const v = this.videos[i]
          var m = v.reg.exec(this.newUrl)
          if (m) {
            var params = Object.assign({}, v.params, this.params)
            var query = Object.keys(params).map(key => key + '=' + params[key]).join('&')
            var and = v.url.indexOf('?') >= 0 ? '&' : '?'
            this.newUrl = this.newUrl.replace(v.reg, v.url) + and + query
            this.valid = true
            break
          }
        }
      }
      if (this.valid) {
        this.content.value.src = this.newUrl
        this.openEditDialog = false
        this.newUrl = ''
      } else {
        this.showMessage(['error', this.$t('error_message.url_invalid')])
      }
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "change_url": "Change url"
  },
  "id": {
    "change_url": "Ubah URL"
  }
}
</i18n>
